import { Box, Button, Container, Typography } from '@mui/material'
import { OpenInNew } from '@mui/icons-material'
import CarnivoreBox from '../../../components/carnivore-box'
import { StyleHelper } from '../../../components/style-helper'

const MANAGE_SUBSCRIPTION_URL = 'https://carnivoretrading.com/profile/'

export default function WooSubPage () {
  return (
    <Container sx={{ p: 3 }}>
      <Typography variant='subtitle1' fontWeight={'bold'} color={'primary'}>
        Billing
      </Typography>
      <Typography variant='body2'>
        Manage Your Subscription, billing and payment details.
      </Typography>
      <StyleHelper.VerticalSpace />
      <CarnivoreBox>
        <Typography variant='subtitle1' fontWeight={'bold'} color={'primary'}>
          Manage Subscription
        </Typography>
        <StyleHelper.SmallVerticalSpace />
        <Typography variant='body2'>
          Your subscription, payment methods and invoices are managed on your
          Carnivore Trading profile.
        </Typography>
        <StyleHelper.VerticalSpace />
        <Box>
          <Button
            variant='contained'
            color='primary'
            endIcon={<OpenInNew />}
            href={MANAGE_SUBSCRIPTION_URL}
            target='_blank'
            rel='noopener noreferrer'
          >
            Go to My Profile
          </Button>
        </Box>
      </CarnivoreBox>
    </Container>
  )
}
